import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  contact: {
    width: 100,
    height: 100,
    paths: [
      {
        // style: `fill: #4d4d4d`,
        d: `M81,33.86H75.54v-.4a25.55,25.55,0,0,0-51.09,0v.4H19a5,5,0,0,0-5,5V60.5a5,5,0,0,0,5,5H31.42V33.86h-4A22.49,22.49,0,0,1,32,
          20.21h0c.22-.28.43-.55.66-.82l0,0c.22-.27.44-.52.67-.77l.05-.06c.23-.24.46-.48.7-.71l.07-.07c.23-.23.47-.45.7-.66L35,
          17l.71-.6.14-.11.7-.55.18-.12c.23-.17.46-.34.7-.49a1.64,1.64,0,0,1,
          .22-.14l.68-.44.27-.15c.22-.13.44-.26.67-.38l.3-.16c.22-.11.44-.23.67-.33l.34-.16.65-.29.39-.15.62-.25.44-.15.6-.2.48-.13.59-.17.53-.12.55-.13.58-.1c.18,0,.35-.07.53-.09s.42-.06.64-.09l.48-.06.75-.05.39,0c.38,0,.77,0,1.15,0h0c.38,0,.77,0,1.15,
          0l.4,0,.74.05.49.06c.21,0,.42,0,.63.09s.35.06.53.09l.57.1.56.13.53.12.59.17.47.13.61.2.43.15.63.25.39.15.65.29.34.16.66.33.31.16.67.38.26.15.69.44.22.14c.24.15.47.32.7.49l.18.12.7.55.14.11L65,17l.1.1c.24.21.47.43.7.65l.08.08c.24.23.47.47.69.71l0,
          .06c.23.25.46.5.68.77l0,0c.22.27.44.54.65.82h0a22.45,22.45,0,0,1,4.6,13.29h0v.36h-4V65.51h2.25v8.27a9.15,9.15,0,0,1-9.15,
          9.15H56.75a7,7,0,1,0,.12,3h4.79A12.16,12.16,0,0,0,73.81,73.78V65.51H81a5,5,0,0,0,5-5V38.87A5,5,0,0,0,81,33.86Z`,
      },
      {
        // style: `fill: #eb212e`,
        d: `M4,50a7,7,0,0,0,7,7h0V43h0A7,7,0,0,0,4,50Z`,
      },
      {
        // style: `fill: #eb212e`,
        d: `M89,43h0V57h0a7,7,0,0,0,0-14Z`,
      },
    ],
  },
});
